import { render, staticRenderFns, recyclableRender, components } from "./upsert.vue?vue&type=template&id=2f72df63&"
var renderjs
import script from "./upsert.vue?vue&type=script&lang=js&"
export * from "./upsert.vue?vue&type=script&lang=js&"
import style0 from "./upsert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/address/upsert.vue"
export default component.exports